import React, { PureComponent } from 'react';
import cx from 'classnames';

class ContactsList extends PureComponent {

  render() {
    const { contacts } = this.props;

    return (
      <ul className="list-inline contacts-list">
        {
          contacts.map((contact, index)=> {
            const classObj = {
              'fa': true
            };
            classObj['fa-' + contact.contact_type] = true;
            return (
              <li key={index}><i className={ cx(classObj)}></i> <span className="contact">{contact.contact}</span></li>
            );
          })
        }
      </ul>
    );
  }
}

ContactsList.propTypes = {};
ContactsList.defaultProps = {};

export default ContactsList;



// WEBPACK FOOTER //
// ./src/components/contacts-list/ContactsList.js